// Product analytics: Plausible.
//
// Separate from lib/ads.js on purpose. That file talks to the ad platform and
// exists to attribute spend; this one answers a different question — which
// pages bring people who go on to ask for a demo. The two happen to fire at
// the same moment today, and they are still not the same concern.
//
// Plausible is cookieless and stores no personal data, which is why this site
// has no consent banner. Keep it that way: do not pass anything here that
// could identify a visitor. Custom properties are for shape, not for people —
// which form, which plan, never a name, email or phone number.
//
// The queue stub in public/index.html defines window.plausible before the
// script loads, so a call made early is held rather than lost. Every call is
// still guarded: an ad blocker can remove it entirely, and a visitor leaving
// their details must never be broken by a blocked tracker.

function track(event, props) {
  try {
    if (typeof window.plausible !== "function") return;
    window.plausible(event, props ? { props } : undefined);
  } catch {
    /* measurement must never break a submission */
  }
}

// Fired when a lead is actually created, not when the form is opened or
// submitted — a validation failure is not a conversion. `source` says which
// form it came from, so the booking section and the popup can be told apart
// without a second goal.
export function trackDemoRequested(source) {
  track("Demo requested", source ? { source } : undefined);
}
